export class IbanHelperUtil {
  private static removeAllSpaces(val: string): string {
    return val ? val.replace(/ /g, '') : '';
  }

  public static convertForDisplay(value: string): string {
    if (value) {
      const startVal = IbanHelperUtil.removeAllSpaces(value).toUpperCase();
      const splitted: string[] = startVal.split('');
      let result = '';
      for (let i = 0; i < splitted.length; i++) {
        result += splitted[i];
        if ((i + 1) % 4 === 0 && i < splitted.length - 1) {
          result += ' ';
        }
      }
      return result;
    } else {
      return '';
    }
  }
}
